import { Grid } from '@mui/material'
import React from 'react'
import { useTheme } from '@mui/styles'
import {
  TextRegular,
  TextSemiBold
} from '../../../commonComponents/TextStyling'
import { useNavigate } from 'react-router-dom'
import AppButton from '../../../commonComponents/AppButton'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import { ENV } from '../../../ENV'

export default function Completed ({ candidateState }) {
  const navigate = useNavigate()

  var theme = useTheme()

  return (
    <Grid container>
      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
        <CheckCircleOutlineRoundedIcon
          style={{
            fontSize: '60px',
            color: theme.palette.text.success
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        style={{ display: 'flex', justifyContent: 'center', margin: 24 }}
      >
        <TextSemiBold style={{ fontSize: '18px' }}>
          Congratulations!
        </TextSemiBold>
      </Grid>
      <Grid item xs={12}>
        <TextRegular>
          We will review your job application and send updates to your email{' '}
          <span style={{ color: theme.palette.primary.main }}>
            {candidateState.candidateEmail}.
          </span>{' '}
          Look out for emails from {ENV.product_name}.{' '}
          {candidateState.recruiterFirstName} {candidateState.recruiterLastName}{' '}
          is your primary point of contact during the recruiting process. Good
          luck!
        </TextRegular>
      </Grid>
      <Grid item xs={12} style={{ marginTop: 24, marginBottom: 24 }}>
        <TextRegular>
          NOTE: Once you approve this submission, please DO NOT apply to{' '}
          {candidateState.companyname} for this role {candidateState.jobTitle}{' '}
          or any other jobs directly through their career site or via any other
          channels such as job boards. Your recruiter{' '}
          {candidateState.recruiterFirstName} {candidateState.recruiterLastName}{' '}
          has utilized {ENV.product_name} to share your profile with{' '}
          {candidateState.companyname} and we will present your profile with the
          right decision makers at {candidateState.companyname}. If you have any
          questions, please feel free to reach out to your recruiter or write to{' '}
          <span style={{ color: theme.palette.primary.main }}>
            {ENV.product_mail}
          </span>
        </TextRegular>
      </Grid>
      <div
        style={{
          display: 'flex',
          flex: 1,
          justifyContent: 'center'
        }}
      >
        <AppButton
          name={'OK'}
          fullWidth={false}
          onClick={() => {
            navigate('/')
          }}
        />
      </div>
    </Grid>
  )
}
